import { useCallback, useState } from 'react';

import {
  openChildrenRealignPanel,
  openRealignPanelWithoutChildrenRealignModal,
} from 'components/RabbitOKRSidePanel/krDrawerSecondaryPanelSlice';
import { useDispatch } from 'react-redux';

export const useChangeTimelineRealignModalLogic = ({ details }) => {
  const dispatch = useDispatch();

  const [isChangeTimelineModalOpen, setIsChangeTimelineModalOpen] = useState(false);
  const [selectedTimeBoundPeriod, setSelectedTimeBoundPeriod] = useState(null);

  const onSelectedTimeBoundPeriodChange = useCallback(
    (selectedTimeBoundPeriod) => {
      setSelectedTimeBoundPeriod(selectedTimeBoundPeriod);

      if (details?.okrHasNoChildren) {
        dispatch(
          openRealignPanelWithoutChildrenRealignModal({
            ...details,
            okrTimePeriod: selectedTimeBoundPeriod,
          })
        );
        return;
      }
      setIsChangeTimelineModalOpen(true);
    },
    [details, dispatch]
  );

  const handleCloseModal = useCallback(() => {
    setIsChangeTimelineModalOpen(false);
  }, []);

  const handleRealignChildrenOKRs = useCallback(() => {
    dispatch(openChildrenRealignPanel({ ...details, okrTimePeriod: selectedTimeBoundPeriod }));

    handleCloseModal();
  }, [details, dispatch, handleCloseModal, selectedTimeBoundPeriod]);

  const handleNotRealignChildrenOKRs = useCallback(() => {
    dispatch(
      openRealignPanelWithoutChildrenRealignModal({
        ...details,
        okrTimePeriod: selectedTimeBoundPeriod,
      })
    );

    handleCloseModal();
  }, [details, dispatch, handleCloseModal, selectedTimeBoundPeriod]);

  return {
    isChangeTimelineModalOpen,
    onSelectedTimeBoundPeriodChange,
    handleCloseModal,
    handleRealignChildrenOKRs,
    handleNotRealignChildrenOKRs,
  };
};
